import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentPlan } from 'src/app/_data/current-plan';
import { WhiteLabelList } from 'src/app/_data/white-label-list';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SignupService } from 'src/app/_services/signup.service';

@Component({
    selector: 'app-subscription-plans-lincsell',
    templateUrl: './subscription-plans-lincsell.component.html',
    styleUrls: ['./subscription-plans-lincsell.component.scss'],
})
export class SubscriptionPlansLincsellComponent implements OnInit {
 
    _globals = GlobalService
    currentPlan = CurrentPlan
    trialDaysLeft: number = 0;
    showTrialMessage: boolean = false;
    businessSetup:any;
    isMonthly:boolean = false;


    plans = [];
    
    constructor(
        public _signup: SignupService,
        private _router: Router,
        private _abd:AppBaseDataService,
    ) {}



    ngOnInit(): void {
      // this._abd.showSpinner()
      // try {
      //         this._signup.getSubscriptionPlans().subscribe((res)=>{
      //     this._abd.hideSpinner()
      //           if(res.success){
      //     this.plans =  res.data.filter((p)=>p.isTrial !== true) 
      //   }  
   
      // })
      // } catch (error) {
      //   this._abd.hideSpinner()
      // }
     localStorage.removeItem('goto')
      this.plans = [
        {id:1,planName:"Online Store", selected:false,  detail:"Best for everyone to launch online store",isMonthly:true, monthlyPrice:29 , yearlyPrice:29},
    // {id:2,planName:"POS-Mobile", selected:false,  detail:"Best for small businesses that need quick pos",isMonthly:true, monthlyPrice:99 , yearlyPrice:99},
    {id:3,planName:"POS-Store", selected:false,  detail:"In Store Point of Sale",isMonthly:true, monthlyPrice:129 , yearlyPrice:119},
    {id:4,planName:"Customer App", selected:false,  detail:"Branded customer App",isMonthly:true, monthlyPrice:459 , yearlyPrice:429},
    // {id:5,planName:"Enterprise", selected:false,  detail:"Includes everything from webstore to mobile app",isMonthly:true, monthlyPrice:999 , yearlyPrice:999,CTA:"contact"},
      ]
      


    }
    getRemaintingTime(){
      let businessSetup = this._globals.userInfo?.businessSetup[0];
        let planInfo = this._globals.userInfo?.businessSetup[0]?.subscription;
       
        let IsUserOnTrial=businessSetup?.isFreeTrial
        if (IsUserOnTrial) {
            let startDate: Date = new Date();
            let endDate: Date = new Date(businessSetup?.freeTrialEndDate.toString());

            let diff = Math.abs(endDate.getTime() - startDate.getTime());
            return Math.ceil(diff / (1000 * 3600 * 24));

        }
        else {
            let startDate: Date = new Date(businessSetup?.createdDate.toString());
            let endDate: Date = new Date(planInfo?.nextChargeDate.toString());

            let diff = Math.abs(endDate.getTime() - startDate.getTime());
            return Math.ceil(diff / (1000 * 3600 * 24));
        }
    }
    selectPlan(value:any){

      sessionStorage.setItem('is-Redirect','Yes')
      // this._signup.selectedPlanDetails = value
      // localStorage.setItem('selectedPlanDetails',JSON.stringify(this._signup.selectedPlanDetails))
      console.log(value)
      this._router.navigate(["signup/check-out"])
    }
    goToHome(){
      localStorage.setItem('is_Select_Plan','true')

        this._router.navigate([""])
    }
    goToPlanDetails(){
      window.open("https://lincsell.com/pricing/","_blank");
    }
   
}
